import { TypePredicateManager } from "@whatslly/types/TypePredicateManager";
export const simulatePaste = (el: Element, text: string) => {
  const dataTransfer = new DataTransfer();
  dataTransfer.setData("text", text);
  const event = new ClipboardEvent("paste", {
    clipboardData: dataTransfer,
    bubbles: true,
  });
  if (TypePredicateManager.hasFocusFunction(el)) el.focus();
  el.dispatchEvent(event);
};
